// Spinner — брендовый лоадер для загрузки экрана/данных (внутри кнопок — свой, в Button).
// Размер — динамический prop, поэтому задаётся через style (R6: вычисляемое значение).

export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <span
      role="status"
      aria-label="Загрузка"
      className="inline-block animate-spin rounded-full border-2 border-brand-soft border-t-brand"
      style={{ width: size, height: size }}
    />
  );
}
